/**
 * Progressive text reveal for Rich text (featured-text) sections.
 * Respects prefers-reduced-motion; runs when section scrolls into view.
 */
(function () {
  'use strict';

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function tokenize(text, mode) {
    if (!text) return [];
    if (mode === 'word') {
      return text.split(/(\s+)/).filter(function (t) {
        return t.length > 0;
      });
    }
    return Array.from(text);
  }

  function finishBlock(source, target) {
    if (!source || !target) return;
    var sr = target.querySelector('.fischhaus-text-build-sr-only');
    var stage = target.querySelector('.fischhaus-text-build-stage');
    if (sr) sr.remove();
    if (stage) stage.remove();
    target.innerHTML = source.innerHTML;
    source.remove();
  }

  function runBlock(block, mode, ms) {
    var source = block.querySelector('.fischhaus-text-build-source');
    var target = block.querySelector('[data-fischhaus-text-build-target]');
    if (!source || !target) return Promise.resolve();
    var stage = target.querySelector('.fischhaus-text-build-stage');
    if (!stage) return Promise.resolve();

    var fullText = (source.innerText || source.textContent || '').replace(/^\s+|\s+$/g, '');
    var tokens = tokenize(fullText, mode);
    if (!tokens.length) {
      finishBlock(source, target);
      return Promise.resolve();
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishBlock(source, target);
      return Promise.resolve();
    }

    stage.textContent = '';
    var i = 0;
    return new Promise(function (resolve) {
      function tick() {
        if (i >= tokens.length) {
          finishBlock(source, target);
          resolve();
          return;
        }
        stage.textContent += tokens[i];
        i += 1;
        setTimeout(tick, ms);
      }
      tick();
    });
  }

  function runSequence(root) {
    var mode = root.getAttribute('data-fischhaus-text-build-mode') || 'character';
    if (mode !== 'word') mode = 'character';
    var ms = parseInt(root.getAttribute('data-fischhaus-text-build-ms') || '40', 10);
    if (isNaN(ms) || ms < 8) ms = 8;
    var gap = parseInt(root.getAttribute('data-fischhaus-text-build-gap') || '120', 10);
    if (isNaN(gap) || gap < 0) gap = 0;

    var blocks = Array.prototype.slice.call(root.querySelectorAll('.fischhaus-text-build-block'));
    if (!blocks.length) return Promise.resolve();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      blocks.forEach(function (block) {
        var source = block.querySelector('.fischhaus-text-build-source');
        var target = block.querySelector('[data-fischhaus-text-build-target]');
        finishBlock(source, target);
      });
      return Promise.resolve();
    }

    var wordMode = mode === 'word' ? 'word' : 'character';
    var chain = Promise.resolve();
    blocks.forEach(function (block, idx) {
      chain = chain.then(function () {
        return runBlock(block, wordMode, ms);
      });
      if (idx < blocks.length - 1 && gap > 0) {
        chain = chain.then(function () {
          return sleep(gap);
        });
      }
    });
    return chain;
  }

  function observeRoot(root) {
    if (!root || root.getAttribute('data-fischhaus-text-build-observed')) return;
    if (!root.querySelector('.fischhaus-text-build-block')) return;

    root.setAttribute('data-fischhaus-text-build-observed', 'true');

    var start = function () {
      if (root.getAttribute('data-fischhaus-text-build-done')) return;
      root.setAttribute('data-fischhaus-text-build-done', 'true');
      runSequence(root).catch(function () {});
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      start();
      return;
    }

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          start();
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px 10% 0px' }
    );
    io.observe(root);
  }

  function initAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.featured-text--root[data-fischhaus-text-build="true"]'),
      observeRoot
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.classList || !section.classList.contains('shopify-section')) return;
    var root = section.querySelector('.featured-text--root[data-fischhaus-text-build="true"]');
    if (!root) return;
    root.removeAttribute('data-fischhaus-text-build-observed');
    root.removeAttribute('data-fischhaus-text-build-done');
    observeRoot(root);
  });
})();
